module.exports = __webpack_public_path__ + "img/facebook.015547de.svg";